var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-banner banner-imunitate"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row height-400"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("DA PENTRU "),_c('br'),_vm._v(" IMUNITATE")])])])])])
}]

export { render, staticRenderFns }